// src/assets/theme/functions/index.js

import boxShadow from "./boxShadow";
import hexToRgb from "./hexToRgb";
import linearGradient from "./linearGradient";
import pxToRem from "./pxToRem";
import rgba from "./rgba";

export default {
  boxShadow,
  hexToRgb,
  linearGradient,
  pxToRem,
  rgba,
};
